export type ScenarioSourceMnemonic = {
  mnem: string
  /** in format YYYY-MM-DD */
  date_from: string
  /** in format YYYY-MM-DD */
  date_to: string
}

export type ScenarioSourceMnemonicResponse = ScenarioSourceMnemonic | string

// TODO (Bartek Laskowski) 2026-07-28: temporary fallback to old interface. Remove it after deployment of https://github.com/spglobal-innersource/pgm-backend/pull/437
export function scenarioSourceMnemonicFallback(
  scenarioSourceMnemonic: ScenarioSourceMnemonicResponse,
): ScenarioSourceMnemonic {
  if (typeof scenarioSourceMnemonic === "string") {
    return {
      mnem: scenarioSourceMnemonic,
      date_from: "2000-01-01",
      date_to: "2080-01-01",
    }
  }

  return scenarioSourceMnemonic
}
